import { combineReducers } from 'redux';
import authentication from './authentication';
import userInterface from './userInterface';
import organisations from './organisations';
import surgeries from './surgeries';
import branches from './branches';
import order from './order';
import orders from './orders';
import geozones from './geozones';
import commissions from './commissions';
import configurations from './configurations';
import invoices from './invoices';
import otc from './otc';
import notes from './notes';
import pharmacy from './pharmacy';
import pharmacies from './pharmacies';
import services from './services/reducer';
import options from './options/reducer';
import avatars from './avatars/reducer';
import dashboard from './dashboard';
import getNotesReducer from './notes/getNotesReducer'
import addNoteReducer from './notes/addNoteReducer';
import dashboardReports from './dashboard-reports';
import patientsReportProcessingReducer from './patients-report-processing';
import deliveryOptions from './delivery-options';
import orderTypes from './order-types';
import questionnaire from './questionnaire/reducer';
import clinics from './clinics/reducer';

// Scale features with modules
export default combineReducers({
  authentication,
  userInterface,
  organisations,
  branches,
  order,
  orders,
  geozones,
  commissions,
  surgeries,
  invoices,
  otc,
  notes,
  pharmacy,
  pharmacies,
  configurations,
  services,
  options,
  avatars,
  dashboard,
  dashboardReports,
  getNotes: getNotesReducer,
  addNote: addNoteReducer,
  patientsReportProcess: patientsReportProcessingReducer,
  deliveryOptions,
  orderTypes,
  questionnaire,
  clinics,
});
